import { createPortal } from "react-dom";

// Hooks
import usePortal from "hooks/usePortal";

export default function Portal({ children }) {
  const target = usePortal();

  return createPortal(children, target);
}
